import joi from 'joi';

export const specificStringSchema = <T = string>(...args: T[]) => {
  return joi.string().valid(...args);
};
